/**
 * @generated SignedSource<<42d3f9cdc44ea3bdba888a90d3104cb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UrlCellUrlCell$data = {
  readonly projectUrl: string | null | undefined;
  readonly " $fragmentType": "UrlCellUrlCell";
};
export type UrlCellUrlCell$key = {
  readonly " $data"?: UrlCellUrlCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"UrlCellUrlCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UrlCellUrlCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectUrl"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "49d6a4c545fd917bb61899ea292a8417";

export default node;
